import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';

const PsgTrainingJoditEditor = ({ placeholder, subTitle, editorContent, onContentChange }) => {
  const { id } = useParams();
    const editor = useRef(null);
    const [content, setContent] = useState(editorContent);
    // const insertDefaultTable = (subTitle) => {
    //     let tableHtml = `<table style="border-collapse:collapse;width: 100%;"><tbody>
    //     <tr>
    //     <td style="width: 20%;">S.No</td>
    //     <td style="width: 20%;">Title of the Event</td>
    //     <td style="width: 20%;">Date</td>
    //     <td style="width: 20%;">Venue</td>
    //     <td style="width: 20%;">No of Participents</td>
    //     </tr>
    //     <tr>
    //     <td style="width: 20%;"><br></td>
    //     <td style="width: 20%;"><br></td>
    //     <td style="width: 20%;"><br></td>
    //     <td style="width: 20%;"><br></td>
    //     <td style="width: 20%;"><br></td>       
    //     </tr></tbody></table>`;

    //     setContent("");
    // };

    const insertImage = (resp) => {
        const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
        const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
        const currentContent = editor.current?.value || content;  
        const updatedContent = currentContent + imgHtml;
        setContent(updatedContent);
        onContentChange(updatedContent);
    };

    // Memoized configuration for JoditEditor
    const config = useMemo(() => ({
        readonly: false,
        placeholder: placeholder || '',
        toolbar: {
            buttons: [
                'bold',
                'italic',
                'underline',
                'image', 
                '|', 
                'source', 
            ],
        },
        uploader: {
            insertImageAsBase64URI: false,
            url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt")}`
            },
            method: 'POST',
            prepareData: (formData) => {
                const files = formData.getAll('files[0]'); 
                formData.delete('files[0]'); 
            
                files.forEach((file) => {
                    formData.append('file', file); 
                });
                return formData;
            }
            ,
            isSuccess: (resp) => {
                return resp;
            },
            process: (resp) => {
                console.log('File uploaded successfully:', resp);
                insertImage(resp);
                return {}; 
            },
            error: (e) => {
                console.error('Upload error', e);
            }
        },
        events: {
            beforeImage: function(current) {
                return false; 
            },
            'errorMessage': function(message) {
                console.error(message);
            }
        }
    }), [placeholder, id]);

    useEffect(() => {
        setContent(editorContent);
    }, [subTitle]);

    const handleContentChange = (newContent) => {
        setContent(newContent);
        onContentChange(newContent);
      };

    return (
        <JoditEditor
            ref={editor}
            value={content}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onBlur={(newContent) => handleContentChange(newContent)} // preferred to use only this option to update the content for performance reasons
            onChange={() => {}}
        />
    );
};

export default PsgTrainingJoditEditor;
